import { NamedResourceFormDialog } from "../named_resource_crud";
import type { AccountResponse } from "./accountsAdapter";
import { accountsAdapter } from "./accountsAdapter";

export type AccountFormDialogProps = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  mode: "create" | "edit";
  initialAccount?: AccountResponse | null;
};

export function AccountFormDialog({
  open,
  onOpenChange,
  mode,
  initialAccount,
}: AccountFormDialogProps) {
  return (
    <NamedResourceFormDialog
      adapter={accountsAdapter}
      open={open}
      onOpenChange={onOpenChange}
      mode={mode}
      initialItem={initialAccount}
    />
  );
}
